<template>
  <transition name="app-download-modal">
      <div class="app-download-modal">
        <div class="app-download-modal__mask" v-if="hasMask" @click="clickMask"></div>
        <div class="app-download-modal__wrapper">
          <slot></slot>
          <span class="app-download-modal__x" id="finish" v-if="hasX" @click="clickX">&times;</span>
        </div>
      </div>
    </transition>
</template>

<script>
export default {
  props: [
    'hasX',
    'hasMask',
    'canClickMask'
  ],

  methods: {
    clickX () {
      this.$emit('toggle')
    },

    clickMask () {
      if (this.canClickMask) {
        this.$emit('toggle')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AppDownloadModal.vue?28b0354a